/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ClientsInputs */

const cs_nav_clients = /** @type {(inputs: Nav_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klienti`)
};

const en_nav_clients = /** @type {(inputs: Nav_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clients`)
};

/**
* | output |
* | --- |
* | "Clients" |
*
* @param {Nav_ClientsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_clients = /** @type {((inputs?: Nav_ClientsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ClientsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_clients(inputs)
	return cs_nav_clients(inputs)
});